import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=a486ec0c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-cloudapp-租户用户端网站-html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a486ec0c"]])

export default __exports__